import { useQuery } from '@tanstack/react-query';
import { Sparkles } from 'lucide-react';
import { assistenteService } from './assistenteService';
import styles from './AssistenteWidget.module.css';

type Props = {
  desabilitado: boolean;
  onPerguntar: (pergunta: string) => void;
};

/** Sugestoes do momento (R23): sem entrada depois das 9h, recados sem leitura, resumo depois das 15h. */
export function SugestoesMomentoMia({ desabilitado, onPerguntar }: Props) {
  const sugestoes = useQuery({
    queryKey: ['assistente', 'sugestoes'],
    queryFn: assistenteService.sugestoes,
    staleTime: 60_000,
  });
  if (!sugestoes.data?.length) return null;
  return (
    <div className={styles.sugestoesMomento} aria-label="Agora">
      {sugestoes.data.map((sugestao) => (
        <button
          key={sugestao.id}
          type="button"
          className={`${styles.sugestao} ${styles.sugestaoMomento}`}
          disabled={desabilitado}
          onClick={() => onPerguntar(sugestao.pergunta)}
        >
          <Sparkles size={14} aria-hidden />
          {sugestao.texto}
        </button>
      ))}
    </div>
  );
}
